import { Screen } from '@zapier/theme';
import { useMediaProps } from '@zapier/responsive-utils';
import { mediaQueryValues } from 'components/mediaQueries';

export const useScreenSize = () => {
  const size = useMediaProps({
    all: {
      size: 'mobile',
    },
    [mediaQueryValues.tablet]: { size: 'tablet' },
    [Screen.queries.desktop]: { size: 'desktop' },
  }).size;

  return {
    size,
    isMobile: size === 'mobile',
    isTablet: size === 'tablet',
    isDesktop: size === 'desktop',
  };
};
